<template>
  <div
    :id="id"
    class="intro-section">
    <div class="upper-section">
      <div class="logo">
        <img :src="require(`@/assets/img/icons/nosop3.svg`)" />
      </div>
      <div class="visual">
        <div class="horizon">
          <img
          class="horizon-image"
          :src="require(`@/assets/img/intro-image.gif`)" />
        </div>
      </div>
    </div>
    <div class="page-title-holder">
      <div class="page-title">
        {{content.title}}
      </div>
    </div>
    <div class="intro-text">
      {{ content.text }}
    </div>
    <div class="alert">
      <div class="alert-text">
        <span>
          Scroll verder
        </span>
        <div class="scroll-down">
          <img :src="require(`@/assets/img/icons/arrows.svg`)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BackgroundVideo from '../components/BackgroundVideo.vue'
import { trackSection } from '../utils/track.js'

export default {
  components: {
    BackgroundVideo
  },
  data () {
    return {
      aboveViewport: false
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    tracking: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    trackSection(this.tracking.trackingId)
  },
  methods: {
    getItem (url) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/${url}`)
    }
  }
}
</script>
<style lang="scss" scoped>
  .intro-section {
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
    width: 100%;
    padding-bottom: 80px;
    position:relative;
    align-items: center;
    overflow: hidden;
  }

  .upper-section {
    width: 100%;
    text-align: center;
    background-color: #092a38;
  }

  .logo {
    margin: 20px 0;
    @include tablet {
      margin: 40px 0
    }
  }

  .page-title-holder {
    display: flex;
    margin-top: -15px;
    margin-bottom: 50px;
    align-items: center;
    z-index: 10;
  }

  .page-title {
    display: inline-block;
    margin: auto auto;
    padding: 4px 20px 5px;
    background-color: $nos-op3-white;
    border-radius: 25px;
    font-size: 18px;
    font-weight: bold;
    color: black;

    @include tablet {
      padding: 7px 20px 8px;
      font-size: 24px;
    }
  }

  .visual {
    width: 100%;
  }

  .horizon {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .horizon-image {
    width: 100%;
    vertical-align: bottom;
  }

  .intro-text {
    max-width: 500px;
    padding: 0 40px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #FFFFFF;
    z-index: 2;

    @include bigmobile {
      font-size: 20px;
      line-height: 28px;
    }
  }

  .alert {
    width: 100%;
    margin-top: 100px;
    text-align: center;
    color: #FFFFFF;
    z-index: 2;
  }

  @keyframes arrowDown {
    0% {
      transform: translateY(0px);
      opacity: 0;
    }
    33%, 66% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(8px);
    }
  }
  .scroll-down {
    font-size: 0;
    position: relative;
    z-index: 2;
    text-align: center;
    margin: 20px auto 0;
    opacity: 0.8;
    animation: arrowDown 1700ms infinite;
  }

  .alert-title {
    font-size: 18px;
    font-weight: bold;
  }

  .alert-text {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/sections/IntroSection.vue